import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Lock, Eye, EyeOff } from "lucide-react";
import { LOGO_URL } from "../lib/format";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Estado conservado
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      localStorage.setItem("sf_admin_token", res.data.token);
      toast.success("Bem-vindo, admin");
      navigate("/admin");
    } catch {
      toast.error("Senha inválida");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div
        className="w-full max-w-md border border-white/10 bg-[#12141D] p-8"
        data-testid="admin-login-card"
      >
        <div className="flex items-center gap-3 mb-6">
          <img src={LOGO_URL} alt="logo" className="h-12" />
          <div>
            <div className="label-caps" style={{ color: "#00E5FF" }}>
              Área restrita
            </div>
            <h1 className="font-display text-3xl text-white uppercase">Admin</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label className="label-caps block mb-2">Senha do administrador</Label>
            <div className="relative">
              <Lock
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"
              />
              
              <Input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#0B0D14] border-white/10 focus:border-[#00E5FF] rounded-sm h-11 pl-9 pr-10"
                placeholder="••••••••••"
                data-testid="admin-password-input"
                autoFocus
              />

              {/* Botão configurado para mostrar apenas enquanto estiver pressionado */}
              <button
                type="button"
                onMouseDown={() => setShowPassword(true)}
                onMouseUp={() => setShowPassword(false)}
                onMouseLeave={() => setShowPassword(false)}
                onTouchStart={() => setShowPassword(true)}
                onTouchEnd={() => setShowPassword(false)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors select-none"
                aria-label="Segurar para mostrar a senha"
              >
                {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="btn-primary w-full h-11 text-sm"
            data-testid="admin-login-submit"
          >
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
